import { Component } from 'solid-js';
import { Layer } from '@trimble/web3d-providers';
import { Portal } from 'solid-js/web';
import { LayerGeneralPropertiesPanel } from '../layer-general-properties-panel/LayerGeneralPropertiesPanel';
import { useLayerPopup } from '../utils/layer-popup-utils';

export interface LayerViewPopupProps {
  layer: Layer;
  anchorElement: HTMLElement;
  onClose(): void;
}

export const LayerViewPopup: Component<LayerViewPopupProps> = (props) => {
  let popupRef: HTMLDivElement | undefined;

  useLayerPopup({
    popupRef: () => popupRef,
    anchorElement: () => props.anchorElement,
    onClose: () => props.onClose,
  });

  const handlePopupClick = (): void => {
    props.onClose();
  };

  return (
    <Portal>
      <div
        ref={(el) => {
          popupRef = el;
        }}
        data-testid="layer-view-popup"
        class="fixed z-dropdown-elevated bg-white shadow-lg rounded-md border border-gray-2 p-3 w-[285px] cursor-pointer"
        onClick={handlePopupClick}
      >
        <LayerGeneralPropertiesPanel
          nameToDisplay={props.layer.name}
          colorToDisplay={props.layer.color}
          entityColor={props.layer.color}
          lineThicknessToDisplay={props.layer.lineThickness.toString()}
          lineStyleToDisplay={props.layer.lineStyle}
          canEdit={false}
          allLayers={[]}
          byLayerColor={props.layer.color}
        />
      </div>
    </Portal>
  );
};
